export const localStorageKeys = {
    DATE: 'date',
    SUMMARYDATE: 'summaryDate',
    SIDEBAR: 'sideBar',
    THEME: 'theme',

    SUPERVISIONREPORTUSERID: 'supervisionReportUserId',
    SUPERVISIONREPORTSITEID: 'supervisionReportSiteId',
    SUPERVISIONMYSITES: 'supervisionMySites',
    REPORTINGSTARTDATE: 'reportingStartDate',
    REPORTINGENDDATE: 'reportingEndDate',
    REPORTINGREPORTSUSERID: 'reportingReportUserId',
    TAB: {
        NEEDS: 'needsTab',
        PLANNING: 'planningTab',
        GNR: 'gnrTab',
        SUPERVISION: 'supervisionTab',
        SUMMARY: 'summaryTab',
        VALIDATION: 'validationTab',
        EXPENSES: 'expensesTab',
        ADMINCONFIGURATION: 'adminConfigurationTab',
        ADMINMATERIAL: 'adminMaterialTab',
        ADMININTERNAL: 'adminInternalTab',
        ADMINEXTERNAL: 'adminExternalTab',
        ADMINVEHCILES: 'adminVehiclesTab',
        REPORTING: 'reportingTab',
        PLI: 'pliTab',
        FORMEDIT: 'formEditTab',
    },
    TABLE: {
        PLI: {
            MACHINES: 'machinesPliTable',
            USERS: 'usersPliTable',
            TOOLS: 'toolsPliTable',
            VEHICLES: 'vehiclesPliTable',
            TRUCKS: 'trucksPliTable',
        },
        ADMIN: {
            INTERNAL: {
                USERS: 'usersInternalAdminTable',
                JOBS: 'jobsInternalAdminTable',
                SITES: 'sitesInternalAdminTable',
                ENTITIES: 'entitiesInternalAdminTable',
            },
            VEHICLES: {
                VEHICLES: 'vehiclesVehiclesAdminTable',
                VEHICLETYPES: 'vehicleTypesVehiclesAdminTable',
                TRUCKS: 'trucksVehiclesAdminTable',
                TRUCKTYPES: 'truckTypesVehiclesAdminTable',
                LOADNATURES: 'loadNaturesVehiclesAdminTable',
            },
            MATERIAL: {
                MACHINES: 'machinesMateriallAdminTable',
                MACHINETYPES: 'machinetypesMateriallAdminTable',
                TOOLS: 'toolsMateriallAdminTable',
                TOOLTYPES: 'tooltypesMateriallAdminTable',
                DUMPS: 'dumpsMateriallAdminTable',
                SUPPLIES: 'suppliesMateriallAdminTable',
                WASTE: 'wasteMateriallAdminTable',
            },
            EXTERNAL: {
                GNRSUPPLIERS: 'gnrsuppliersExternalAdminTable',
                QUARRIES: 'quarriesExternalAdminTable',
                RENTALS: 'rentalsExternalAdminTable',
                TRUCKCOMPANIES: 'truckcompaniesExternalAdminTable',
                TEMPWORKERS: 'tempworkersExternalAdminTable',
                SUBCONTRACTORS: 'subcontractorsExternalAdminTable',
                COMPANIES: 'companiesExternalAdminTable',
            },
        },
        OPERATIONS: {
            GNR: {
                REQUESTED: 'requestedGnrOperationsTable',
                PLANNED: 'plannedGnrOperationsTable',
                DELIVERED: 'deliveredGnrOperationsTable',
                CANCEL: 'cancelGnrOperationsTable',
                ARCHIVED: 'archivedGnrOperationsTable',
            },
            PLANNING: {
                GLOBAL: 'globalPlanningOperationsTable',
                AMPLIROLL: 'amplirollPlanningOperationsTable',
            },
            SUPERVISION: {
                ACTIVITIES: 'activitiesSupervisionOperationsTable',
                TRUCKS: 'trucksSupervisionOperationsTable',
            },
            VALIDATION: {
                ACTIVITIES: 'activitiesValidationOperationsTable',
                REPORTS: 'reportsValidationOperationsTable',
            },
            EXPENSES: {
                GLOBAL: 'globalExpensesOperationsTable',
            },
        },
    },
};
